import { styled } from 'styled-system/jsx'

const TileRoot = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '16px',
    backgroundColor: '#FAF7FF',
    borderRadius: 'lg',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
  },
})

const TileTopRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
})

const TileLabel = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const StatusChip = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '22px',
    paddingX: '10px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  variants: {
    tone: {
      idle: { backgroundColor: '#F1ECFF', color: 'quickpass.primary' },
      enabled: { backgroundColor: '#D7F5E1', color: '#10663A' },
      denied: { backgroundColor: '#FFE3DD', color: '#8B1E2C' },
      neutral: { backgroundColor: '#E5E0F5', color: 'quickpass.inkSoft' },
    },
  },
})

const Description = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.45',
  },
})

const ActionRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
})

const PrimaryButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    borderRadius: 'pill',
    paddingX: '14px',
    paddingY: '7px',
    cursor: 'pointer',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: {
      opacity: '0.9',
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: '0.6',
    },
  },
})

const SecondaryButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    backgroundColor: 'transparent',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'pill',
    paddingX: '14px',
    paddingY: '7px',
    cursor: 'pointer',
    transition: 'border-color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: '0.6',
    },
  },
})

export {
  TileRoot,
  TileTopRow,
  TileLabel,
  StatusChip,
  Description,
  ActionRow,
  PrimaryButton,
  SecondaryButton,
}
